// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-30335954] .el-tabs__item{font-size:12px;padding:0 10px!important}[data-v-30335954] .el-pagination.is-background .btn-next,[data-v-30335954] .el-pagination.is-background .btn-prev,[data-v-30335954] .el-pagination.is-background .el-pager li{background-color:#e2e8f4}[data-v-30335954] .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:#265480}", ""]);
// Exports
module.exports = exports;
